import { CustomerOrdersApiError } from './errors'
import type { CustomerOrderStatus } from './types'

export const buildOrdersListPath = (options: {
  status?: CustomerOrderStatus
  limit?: number
} = {}) => {
  const query = new URLSearchParams()
  if (options.status) query.set('status', options.status)
  if (typeof options.limit === 'number' && Number.isFinite(options.limit) && options.limit > 0) {
    query.set('limit', String(Math.floor(options.limit)))
  }
  const suffix = query.toString()
  return `/orders/me${suffix ? `?${suffix}` : ''}`
}

export const normalizeRequiredOrderId = (orderId: string) => {
  const normalizedId = orderId.trim()
  if (!normalizedId) {
    throw new CustomerOrdersApiError(400, 'ID ordine non valido')
  }
  return normalizedId
}
